import { z } from "zod"

import {
  SortingOrder,
  WarehouseAreaListFilterSchema,
  WarehouseAreaSortField,
  WarehouseTypeSchema,
} from "@/graphql/codegen/graphql"

export const WarehouseSearchParamsSchema = z.object({
  ...WarehouseAreaListFilterSchema().shape,
  field: z.nativeEnum(WarehouseAreaSortField).optional().default(WarehouseAreaSortField.CompanyName),
  order: z.nativeEnum(SortingOrder).default(SortingOrder.Asc),
  query: z.string().optional().default(""),
  types: z.array(WarehouseTypeSchema).nullish().default(null),
})
